export const UnitOfMeasureForm = {
  model: 'UnitOfMeasure',
  format: [
    {
      widths: 'equal',
      fields: {
        singular_name: {
          type: 'text',
        },
        plural_name: {
          type: 'text',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        short_name: {
          type: 'text',
        },
        short_symbol: {
          type: 'text',
        },
      },
    },
  ],
}
